import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserWarehouseGame from 'src/games/WarehouseGame/Main';

interface WarehouseGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class WarehouseGame extends React.Component<WarehouseGameProps> {
    constructor(props: WarehouseGameProps) {
        super(props);
        bindAllOfThis(this, WarehouseGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserWarehouseGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default WarehouseGame;



// WEBPACK FOOTER //
// ./src/pages/game/WarehouseGame.tsx